<div class="permission-denied-modal">
  <div class="permission-denied-modal__header">
    <div class="permission-denied-modal__error-icon">
      <i class="pi pi-times"></i>
    </div>
    <div class="permission-denied-modal__header-text">
      <h2 class="permission-denied-modal__title">Access Denied</h2>
      <p class="permission-denied-modal__subtitle">
        You don't have permission to access this resource
      </p>
    </div>
  </div>

  <div class="permission-denied-modal__body">
    <div class="permission-denied-modal__permission-info">
      <h4 class="permission-denied-modal__info-title">MISSING PERMISSION</h4>
      <p class="permission-denied-modal__info-description">
        {{ permissionData?.message?.message }}
      </p>
      <div class="permission-denied-modal__permission-code">
        {{ permissionData?.message?.required_permission?.name }}
      </div>
    </div>

    <div class="permission-denied-modal__solution-section" *ngIf="permissionData?.message?.steps?.length">
      <h4 class="permission-denied-modal__solution-title">How to Fix This:</h4>
      <ol class="permission-denied-modal__steps">
        <li class="permission-denied-modal__step" *ngFor="let step of permissionData?.message?.steps; let i = index">
            <span class="permission-denied-modal__step-number">{{ i + 1 }}</span>
            <div class="permission-denied-modal__step-content">
              <span [innerHTML]="step.description"></span>
            </div>
        </li>
      </ol>
    </div>
  </div>

  <div class="permission-denied-modal__footer">
    <span class="permission-denied-modal__auto-close">
      Auto-closing in {{ remainingSeconds }}s
    </span>
    <div class="permission-denied-modal__actions">
      <button class="btn btn-secondary" (click)="onCloseClick()">Close</button>
    </div>
  </div>
</div>
